module.exports = __webpack_public_path__ + "static/media/top-left-rectangle.a16e4cd2.png";